import { render, staticRenderFns } from "./view13.vue?vue&type=template&id=066765a0&scoped=true"
import script from "./view13.vue?vue&type=script&lang=js"
export * from "./view13.vue?vue&type=script&lang=js"
import style0 from "./view13.vue?vue&type=style&index=0&id=066765a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066765a0",
  null
  
)

export default component.exports